import { isNotEmpty, useForm } from '@mantine/form'
import { Button, Checkbox, Flex, Paper, Text } from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import InputBudgetYear from '../input/InputBudgetYear'
import { useState } from 'react'
import InputProjectProgressStatus from '../input/InputProjectProgressStatus'
import { IRequestDashboardData } from '@interfaces/api/IDashboard'
import { notifications } from '@mantine/notifications'
import { IconExclamationCircle } from '@tabler/icons-react'
import { singleYearDashboardAgencyOptions, singleYearDashboardOtherOptions, singleYearDashboardProjectOptions } from '@config/dashboard'

const FormSettingDashboardMultipleYear = ({ aftersuccess }: { aftersuccess?: () => any }) => {
  const navigate = useNavigate()
  const [allCheck, setAllCheck] = useState(false)
  const [allProjectOptionCheck, setAllProjectOptionCheck] = useState(false)
  const [allAgencyOptionCheck, setAllAgencyOptionCheck] = useState(false)
  const [allPersonOptionCheck, setAllPersonOptionCheck] = useState(false)

  const form = useForm<IRequestDashboardData>({
    initialValues: {
      start_budget_year: '',
      end_budget_year: '',
      page: 1,
      project_progress_status_id: '',
      opt_project_budget_stats: false,
      opt_project_budget_by_quarter: false,
      opt_project_budget_by_type: false,
      opt_project_budget_ranking: false,
      opt_project_evaluation_summary: false,
      opt_project_evaluation_ranking: false,
      opt_project_registered_stats: false,
      opt_agency_new_and_old_stats: false,
      opt_agency_new_and_old_lists: false,
      opt_agency_amount_by_type: false,
      opt_agency_budget_by_type: false,
      opt_agency_budget_ranking: false,
      opt_coordinator_evaluation_with_budget_ranking: false,
      opt_chairman_new_and_old_stats: false,
      opt_chairman_new_and_old_lists: false,
      opt_chairman_evaluation_with_budget_ranking: false,
      opt_lecturer_evaluation_ranking: false,
      opt_vendor_new_and_old_stats: false,
      opt_vendor_new_and_old_lists: false,
      opt_vendor_evaluation_ranking: false,
    },
    validate: {
      start_budget_year: isNotEmpty('กรุณากรอกข้อมูล'),
    },
  })

  const checkForm = () => {
    return !!Object.values(form.values).filter((v) => v === true).length
  }

  const formOnSubmit = async () => {
    if (!checkForm()) {
      notifications.show({
        title: 'เกิดข้อผิดพลาด',
        message: 'กรุณาเลือกรายการข้อมูลที่ต้องการสรุปผล',
        color: 'red',
        icon: <IconExclamationCircle size="1rem" />,
      })
      return
    }
    navigate('/dashboard/present', { state: form.values })
  }

  const onAllCheckChange = (check: boolean) => {
    toggleCheckAllProjectOption(check)
    toggleCheckAllAgencyOption(check)
    toggleCheckAllPersonOption(check)
    setAllCheck(check)
  }

  const toggleCheckAllProjectOption = (check: boolean) => {
    setAllProjectOptionCheck(check)
    singleYearDashboardProjectOptions.map((option, index) => form.setFieldValue(option.key, check))
  }
  const toggleCheckAllAgencyOption = (check: boolean) => {
    setAllAgencyOptionCheck(check)
    singleYearDashboardAgencyOptions.map((option, index) => form.setFieldValue(option.key, check))
  }

  const toggleCheckAllPersonOption = (check: boolean) => {
    setAllPersonOptionCheck(check)
    singleYearDashboardOtherOptions.map((option, index) => form.setFieldValue(option.key, check))
  }

  return (
    <Paper pos="relative" p="lg" withBorder>
      <form onSubmit={form.onSubmit(formOnSubmit)}>
        <Flex gap="sm" direction="column">
          <Flex gap="md" w="100%">
            <InputBudgetYear
              w="100%"
              withAsterisk
              {...form.getInputProps('start_budget_year')}
              label="ปีงบประมาณที่ต้องการดูผลการดำเนินโครงการ (เริ่มต้น)"
            />
            <InputBudgetYear
              w="100%"
              withAsterisk
              {...form.getInputProps('end_budget_year')}
              label="ปีงบประมาณที่ต้องการดูผลการดำเนินโครงการ (สิ้นสุด)"
            />
            <InputProjectProgressStatus withAsterisk w="250px" label="สถานะโครงการ" {...form.getInputProps('project_progress_status_id')} />
          </Flex>
          <Flex direction="column" gap="lg" mt="sm">
            <Checkbox
              checked={allCheck}
              onChange={(e) => onAllCheckChange(e.target.checked)}
              label={<Text fw="bold">รายการข้อมูลที่ต้องการสำหรับสรุปข้อมูลผลการดำเนินโครงการประจำปีงบประมาณที่เลือก</Text>}
            />
            <Flex direction="column" gap="sm">
              <Checkbox
                checked={allProjectOptionCheck}
                onChange={(e) => toggleCheckAllProjectOption(e.target.checked)}
                label={
                  <Text size="sm" fw="bold">
                    สรุปผลข้อมูลโครงการ
                  </Text>
                }
              />
              {singleYearDashboardProjectOptions.map((option) => (
                <Checkbox key={option.key} {...form.getInputProps(option.key, { type: 'checkbox' })} label={option.label} />
              ))}
            </Flex>
            <Flex direction="column" gap="sm">
              <Checkbox
                checked={allAgencyOptionCheck}
                onChange={(e) => toggleCheckAllAgencyOption(e.target.checked)}
                label={
                  <Text size="sm" fw="bold">
                    สรุปผลข้อมูลหน่วยงาน/ลูกค้า
                  </Text>
                }
              />
              {singleYearDashboardAgencyOptions.map((option) => (
                <Checkbox key={option.key} {...form.getInputProps(option.key, { type: 'checkbox' })} label={option.label} />
              ))}
            </Flex>
            <Flex direction="column" gap="sm">
              <Checkbox
                checked={allPersonOptionCheck}
                onChange={(e) => toggleCheckAllPersonOption(e.target.checked)}
                label={
                  <Text size="sm" fw="bold">
                    สรุปผลข้อมูลผลดำเนินโครงการ ของผู้ประสานงาน ประธานโครงการ วิทยากร และผู้ค้า
                  </Text>
                }
              />
              {singleYearDashboardOtherOptions.map((option) => (
                <Checkbox key={option.key} {...form.getInputProps(option.key, { type: 'checkbox' })} label={option.label} />
              ))}
            </Flex>

            <Flex mt="md" justify="end" gap="sm">
              <Button type="submit" w="fit-content">
                ประมวลผลสรุปข้อมูล
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </form>
    </Paper>
  )
}

export default FormSettingDashboardMultipleYear
